import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { Call, CallStatus } from "@scrile/api-provider/dist/api/CallsProvider";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import { $t } from "@/lib/i18nHelpers";
import { toTimePassed } from "@/lib/time";

@Component({ name: "CallStatusView" })
export default class CallStatusView extends Vue {
  @Prop({ type: Object, required: true })
  public readonly user!: UserPublicData;

  @Prop({ required: true })
  public readonly call!: Call | null;

  @Prop({ type: Boolean, required: true })
  public readonly connectionError!: boolean;

  public get callStatus(): CallStatus {
    return this.call ? this.call.status : CallStatus.NEW;
  }

  public time: number | null = null;

  public interval: number | NodeJS.Timeout = 0;

  public get screenName() {
    return this.user.screenName;
  }

  public get callEnded() {
    return [CallStatus.DECLINED, CallStatus.CANCELLED, CallStatus.ENDED].includes(this.callStatus);
  }

  public get description() {
    if (this.connectionError) return "";
    if (this.time !== null) {
      return toTimePassed(this.time * 1000);
    }
    if (this.callEnded) return $t("Call ended");
  }
  @Watch("callStatus", { immediate: true })
  public onStatusChanged(status: CallStatus) {
    if (status === CallStatus.ACCEPTED) this.startTimer();
    else if (this.callEnded) this.stopTimer();
  }

  public startTimer() {
    if (this.interval) return;
    this.time = 0;
    this.interval = setInterval(() => {
      if (this.time !== null) {
        this.time += 1;
      }
    }, 1000);
  }

  public stopTimer() {
    if (typeof this.interval === "number") {
      clearInterval(this.interval);
    } else clearInterval(this.interval);
    this.interval = 0;
    this.time = null;
  }

  public beforeDestroy() {
    this.stopTimer();
  }
}
